<template>
	<div class="behavior-chart-container">
		<div class="chart-header">
			<div class="period-selector">
				<span>统计周期：</span>
				<el-select v-model="selectedPeriod" size="small" @change="handlePeriodChange">
					<el-option v-for="item in periodOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
				</el-select>
			</div>
		</div>
		<jr-echarts ref="echartsRef" :options="chartOptions" :height="height" :width="width" />
	</div>
</template>

<script>
	import JrEcharts from './index.vue'

	// 企业行为记录-柱状图
	export default {
		name: 'BehaviorBarChart',
		components: {
			JrEcharts
		},
		props: {
			width: {
				type: String,
				default: '100%'
			},
			height: {
				type: String,
				default: '350px'
			},
			title: {
				type: String,
				default: ''
			},
			// 良好行为数据
			goodBehaviorData: {
				type: Array,
				default: () => []
			},
			// 不良行为数据
			badBehaviorData: {
				type: Array,
				default: () => []
			},
			// 黑名单数据
			blacklistData: {
				type: Array,
				default: () => []
			},
			// 月份数据
			monthData: {
				type: Array,
				default: () => ['1月', '2月', '3月', '4月', '5月', '6月']
			},
			// 默认选择的周期
			defaultPeriod: {
				type: String,
				default: 'year'
			}
		},
		data() {
			return {
				selectedPeriod: this.defaultPeriod,
				periodOptions: [
					{ value: 'month', label: '近一月' },
					{ value: 'quarter', label: '近一季度' },
					{ value: 'halfYear', label: '近半年' },
					{ value: 'year', label: '近一年' }
				]
			}
		},
		computed: {
			chartOptions() {
				return {
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'shadow'
						}
					},
					legend: {
						data: ['良好行为', '不良行为', '黑名单'],
						bottom: 0
					},
					grid: {
						left: '3%',
						right: '4%',
						bottom: '10%',
						top: '3%',
						containLabel: true
					},
					xAxis: {
						type: 'category',
						data: this.monthData,
						axisTick: {
							alignWithLabel: true
						},
						splitLine: {
							// 显示X轴网格线
							show: true,
							lineStyle: {
								color: '#eee', // 网格线颜色
								type: 'border' // 网格线样式
							}
						},
						// 添加X轴名称
						name: '月份',
						nameLocation: 'middle',
						nameGap: 25
					},
					yAxis: {
						type: 'value',
						minInterval: 1,
						splitLine: {
							lineStyle: {
								type: 'border'
							}
						},
						// 添加Y轴名称
						name: '次数',
						nameLocation: 'middle',
						nameGap: 30
					},
					series: [
						{
							name: '良好行为',
							type: 'bar',
							barWidth: '20%',
							itemStyle: {
								color: '#67C23A'
							},
							data: this.goodBehaviorData
						},
						{
							name: '不良行为',
							type: 'bar',
							barWidth: '20%',
							itemStyle: {
								color: '#409EFF'
							},
							data: this.badBehaviorData
						},
						{
							name: '黑名单',
							type: 'bar',
							barWidth: '20%',
							itemStyle: {
								color: '#F56C6C'
							},
							data: this.blacklistData
						}
					]
				}
			}
		},
		methods: {
			handlePeriodChange(value) {
				// 触发周期变更事件，让父组件可以根据选择的周期更新数据
				this.$emit('period-change', value)
			}
		}
	}
</script>

<style lang="scss" scoped>
	.behavior-chart-container {
		.chart-header {
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-bottom: 15px;

			.chart-title {
				font-size: 16px;
				font-weight: 500;
				color: #333;
			}

			.period-selector {
				display: flex;
				align-items: center;

				span {
					margin-right: 8px;
					color: #606266;
				}
			}
		}
	}
</style>
